import { ReportTab } from '../modules/reports/types'
import { Country, CountryAndReportGenerationFlags } from '../types'

export const filterCountriesByReportType = (tab: ReportTab, data: CountryAndReportGenerationFlags[]): CountryAndReportGenerationFlags[] => {
  let field: string | null = null
  switch (tab) {
    case ReportTab.MeetingReport:
      field = 'createSmallReport'
      break
    case ReportTab.BigReport:
      field = 'createBigReport'
      break
    case ReportTab.PyramidReport:
      field = 'createPyramidReport'
      break
  }
  const res = data.filter((el) => (!!field ? el[field] === true : true) && el.country !== Country.Default)
  return res
}

export const insertElementAtPositionIntoArray = (array: unknown[], element: unknown, position: number): unknown[] => {
  if (position < 0) {
    return array
  }
  const res = [...array.slice(0, position), element, ...array.slice(position)]
  return res
}
